@if (isVisible()) {
  <div class="fixed inset-0 z-[9999] bg-[linear-gradient(to_bottom,#ffffff,#eef4ff)] font-['Mapei','Roboto',sans-serif] flex flex-col">
    <div class="flex-1 flex flex-col items-center justify-center px-4 pb-8">
      <div class="flex flex-col items-center gap-6 w-full max-w-2xl">

        <div [class]="'w-20 h-20 rounded-full flex items-center justify-center mb-2 animate-fade-in shadow-md ' + getColorClasses().bg">
          <lucide-icon
            [name]="getIcon()"
            [class]="'w-12 h-12 ' + getColorClasses().icon">
          </lucide-icon>
        </div>

        <div class="text-center animate-fade-in">
          <h3 [class]="'text-2xl font-bold mb-1 ' + getColorClasses().text">
            {{ getTitle() }}
          </h3>
          <p class="text-base text-gray-700 leading-snug">
            {{ message() }}
          </p>
        </div>

        @if (buttons().length > 0) {
          <div class="w-full flex flex-col gap-4 mt-2 animate-fade-in">
            @for (button of buttons(); track $index) {
              <app-ui-button
                [variant]="button.variant"
                [icon]="button.icon"
                iconSize="h-5 w-5 sm:h-6 sm:w-6"
                (buttonClick)="button.action()"
                class="w-full text-base"
                [class.shadow-md]="button.variant === 'primary'">
                {{ button.label }}
              </app-ui-button>
            }
          </div>
        }

      </div>
    </div>
  </div>
}
